import { defineCopy } from '@floorfile/i18n'
import { deviationsOosCopy } from './copy'

export const deviationsOosOfflineCopy = defineCopy('deviations-oos', { offlineAction: deviationsOosCopy.en.offlineAction })
